<div class="u-flex-row">
    <div *ngFor="let bar of counterArray; let i = index" class="__bar u-border-radius-large" [class]="i < current ? powerClass : ''"></div>
</div>
